import { render, staticRenderFns } from "./TabSort.vue?vue&type=template&id=07e2e7d6&scoped=true&"
import script from "./TabSort.vue?vue&type=script&lang=coffee&"
export * from "./TabSort.vue?vue&type=script&lang=coffee&"
import style0 from "./TabSort.vue?vue&type=style&index=0&id=07e2e7d6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e2e7d6",
  null
  
)

export default component.exports